import ConfigInfo from './config'
import InterfaceList from './../service'
import { getPosition } from './geoLocation'

export default {
    install (Vue) {
        let VuePrototype = Vue.prototype
        // 配置公共信息
        VuePrototype.$configInfo = ConfigInfo

        VuePrototype.$getPosition = getPosition

        // 接口
        VuePrototype.$asyncAjax = InterfaceList
    }
}
